'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('guidance', {
      url: '/account/housing/guidance',
      template: '<guidance></guidance>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/guidance/guidance.routes.js